import { useTranslation } from 'react-i18next';
import { EnumTransactionItemType } from 'api';
export const getRemittanceType = transactionItemType => {
  const {
    t
  } = useTranslation();
  switch (transactionItemType) {
    case EnumTransactionItemType.DepositPayout:
      return t('remittance.type.deposit');
    case EnumTransactionItemType.DunningCredit:
      return t('remittance.type.invoice_fee');
    case EnumTransactionItemType.Passing:
      return t('remittance.type.passing');
    case EnumTransactionItemType.OverPayment:
      return t('remittance.type.overpayment');
    case EnumTransactionItemType.PaymentFromDeviationToLedger:
      return t('remittance.type.overpayment');
    case EnumTransactionItemType.WriteOff:
      return t('remittance.type.writeoff');
    default:
      return t('remittance.type.other');
  }
};